// 前提: tokenをunstated-next経由で呼び出すために、Authを関数型コンポーネントに直している最中。

import React from "react";
import { Redirect, Route } from "react-router-dom";
import { checkAuthToken } from "../../modules/auth";

interface IProps {
  children: React.ReactNode;
}

const Auth: React.FC<IProps> = ({ children }) => {
  return checkAuthToken() ? (
    <Route children={children} />
  ) : (
    <Redirect to={"/login"} />
  );
};

export default Auth;
